import React from 'react'
import './Categorywise.css'

export default function Categorywise() {
    return (
        <div className='category'>
            <div className='men_section'>
                <h2 className='gender_specification'>
                    <strong>Shop</strong>
                    <span className='golden_gender'>Men's</span>
                </h2>
                <div className='item'>
                    <h1>Comming Soon</h1>
                </div>
            </div>
            <div className='women_section'>
                <h2 className='gender_specification'>
                    <strong>Shop</strong>
                    <span className='golden_gender'>Women's</span>
                </h2>
                <div className='item'>
                    <h1>Comming Soon</h1>
                </div>
            </div>

            {/* For Mobile UI */}
            <div className='category_mobile_view'>
                <div className='gender_category'>
                    <img src='https://cdn.eyemyeye.com/mobile/images/Home/men-avtar.jpg' alt='Men' />
                    <div className='gender'>MEN</div>

                </div>
                <div className='gender_category'>
                    <img src='https://cdn.eyemyeye.com/mobile/images/Home/women-avtar.jpg' alt='Women' />
                    <div className='gender'>WOMEN</div>

                </div>

            </div>
        </div>
    )
}
